import React, { useEffect, useState } from 'react';
import { ShoppingBag, X } from 'lucide-react';
const recentSales = [{
  name: 'María L.',
  location: 'Buenos Aires',
  time: 'hace 2 minutos'
}, {
  name: 'Carlos R.',
  location: 'Córdoba',
  time: 'hace 5 minutos'
}, {
  name: 'Ana G.',
  location: 'Rosario',
  time: 'hace 8 minutos'
}, {
  name: 'Jorge M.',
  location: 'Mendoza',
  time: 'hace 12 minutos'
}, {
  name: 'Laura S.',
  location: 'La Plata',
  time: 'hace 15 minutos'
}, {
  name: 'Pedro V.',
  location: 'Mar del Plata',
  time: 'hace 18 minutos'
}, {
  name: 'Silvia T.',
  location: 'Tucumán',
  time: 'hace 22 minutos'
}, {
  name: 'Roberto F.',
  location: 'Salta',
  time: 'hace 25 minutos'
}, {
  name: 'Claudia N.',
  location: 'Santa Fe',
  time: 'hace 30 minutos'
}, {
  name: 'Miguel A.',
  location: 'Neuquén',
  time: 'hace 35 minutos'
}];
export function SalesNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Show first notification after 5 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed) return;
    const interval = setInterval(() => {
      // Hide current notification
      setIsVisible(false);
      // After animation, show next notification
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % recentSales.length);
        setIsVisible(true);
      }, 500);
    }, 25000); // Every 25 seconds
    return () => clearInterval(interval);
  }, [isDismissed]);
  // Auto-hide notification after 6 seconds
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 6000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, currentIndex, isDismissed]);
  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
  };
  const currentSale = recentSales[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-245">
      <div className="bg-white rounded-xl shadow-2xl border border-stone-200 p-4 pr-10 max-w-xs relative overflow-hidden" data-id="element-246">
        {/* Accent bar */}
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-emerald-500" data-id="element-247" />

        <button onClick={handleDismiss} className="absolute top-2 right-2 p-1 text-stone-400 hover:text-stone-600 transition-colors" aria-label="Cerrar notificación" data-id="element-248">
          <X className="w-4 h-4" data-id="element-249" />
        </button>

        <div className="flex items-start gap-3" data-id="element-250">
          <div className="flex-shrink-0 w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center" data-id="element-251">
            <ShoppingBag className="w-5 h-5 text-emerald-600" data-id="element-252" />
          </div>
          <div data-id="element-253">
            <p className="text-sm font-medium text-stone-900" data-id="element-254">
              {currentSale.name} de {currentSale.location}
            </p>
            <p className="text-sm text-stone-600" data-id="element-255">
              compró <span className="font-medium" data-id="element-256">Cuidador Sin Caos</span>
            </p>
            <p className="text-xs text-stone-400 mt-1" data-id="element-257">{currentSale.time}</p>
          </div>
        </div>

        {/* Progress bar */}
        <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-stone-100" data-id="element-258">
          <div className={`h-full bg-emerald-500 transition-all ease-linear ${isVisible ? 'w-0' : 'w-full'}`} style={{
          transitionDuration: isVisible ? '6000ms' : '0ms',
          width: isVisible ? '100%' : '0%'
        }} data-id="element-259" />
        </div>
      </div>
    </div>;
}